import { Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';
import { Text } from '@chakra-ui/react';
import SubmissionContexts from 'src/pages/Organization/Workspace/SubmissionContexts';
import ProtectedHOC from 'src/components/ProtectedHOC';
import ManageWorkspaceRoutes from './Manage';
import Graph from 'src/pages/Organization/Workspace/SubmissionContexts/Graph';
import WorkspaceSubmissions from 'src/pages/Organization/Workspace/Submissions';
import SubmissionDetails from 'src/pages/SubmissionDetails';
import JournalArchive from 'src/pages/Organization/Workspace/SubmissionContexts/Archive';
import Users from 'src/pages/Organization/Workspace/SubmissionContexts/Users';
import WorkFlows from 'src/pages/Organization/Workspace/SubmissionContexts/WorkFlow';
import WorkspaceProvider from 'src/contexts/WorkspaceProvider';

const WorkspaceRoutes = (
  <Route
    path="workspace/:shortname"
    element={
      <WorkspaceProvider>
        <ProtectedHOC
          relation="canView"
          entityType="workspace"
          entityKey="shortname"
        >
          <Outlet />
        </ProtectedHOC>
      </WorkspaceProvider>
    }
  >
    <Route
      index
      element={<Text textStyle="headingTitle">Workspace Landing page</Text>}
    />
    <Route path="journals" element={<SubmissionContexts />} />
    <Route path="submissions" element={<WorkspaceSubmissions />} />
    <Route path="archive" element={<JournalArchive />} />
    <Route path="users" element={<Users />} />
    <Route path="workflow" element={<WorkFlows />} />

    {ManageWorkspaceRoutes}

    <Route path="j/:ctxId/submissions" element={<Outlet />}>
      <Route
        index
        element={
          <ProtectedHOC
            relation="submissions_workflow_viewer"
            entityType="submissionContext"
            entityKey="ctxId"
          >
            <SubmissionDetails />
          </ProtectedHOC>
        }
      />

      <Route
        path=":submissionId"
        element={
          <ProtectedHOC
            relation="workflow_viewer"
            entityType="submission"
            entityKey="submissionId"
          >
            <SubmissionDetails />
          </ProtectedHOC>
        }
      />
    </Route>
    <Route
      path="j/:ctxId/graph"
      element={
        <Suspense fallback={<div>Loading</div>}>
          <Graph />
        </Suspense>
      }
    />
  </Route>
);

export default WorkspaceRoutes;
